var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('PieChart',{attrs:{"chartData":_vm.baseChartData,"options":_vm.options,"height":200,"flag":_vm.flag}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }